module.exports = {
    port: 3000,
    environment: 'LOCAL'
}